import script from "./EcommerceWarrantyPolicies.vue?vue&type=script&setup=true&lang=js"
export * from "./EcommerceWarrantyPolicies.vue?vue&type=script&setup=true&lang=js"

import "./EcommerceWarrantyPolicies.vue?vue&type=style&index=0&id=47949342&scoped=true&lang=css"

import exportComponent from "C:\\laragon\\www\\unensecommerce\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47949342"]])

export default __exports__